import { BaseLayerNames, TrafficLayerName } from 'map/layers'

export enum MarkerEvent {
  MarkersUpdate = 'MarkersUpdate',
}

export interface SearchInAreaBounds {
  lat: number
  lng: number
  zoom: number
}

export type MapLayers = {
  [BaseLayerNames.OMV]?: H.map.layer.Layer
  [BaseLayerNames.SATELLITE]?: H.map.layer.Layer
  [TrafficLayerName]?: H.map.layer.Layer
}
